export type HomeNeglectState = 'restored' | 'settled' | 'dim' | 'tired'

export interface HomeNeglect {
  state: HomeNeglectState
  awayMs: number
  light: number
  emberEnergy: number
}

const HOUR_MS = 60 * 60 * 1000
const DIM_AFTER_MS = 12 * HOUR_MS
const TIRED_AFTER_MS = 36 * HOUR_MS
const MAX_PRESSURE_MS = 72 * HOUR_MS

function clamp01(value: number): number {
  return Math.max(0, Math.min(1, value))
}

export function computeHomeNeglect(lastReturnedHomeAt: number, now = Date.now()): HomeNeglect {
  const awayMs = Math.max(0, now - lastReturnedHomeAt)
  if (awayMs < DIM_AFTER_MS) {
    return { state: 'restored', awayMs, light: 1, emberEnergy: 1 }
  }

  if (awayMs < TIRED_AFTER_MS) {
    const pressure = clamp01((awayMs - DIM_AFTER_MS) / (TIRED_AFTER_MS - DIM_AFTER_MS))
    return {
      state: 'settled',
      awayMs,
      light: 1 - pressure * 0.2,
      emberEnergy: 1 - pressure * 0.15,
    }
  }

  const pressure = clamp01((awayMs - TIRED_AFTER_MS) / (MAX_PRESSURE_MS - TIRED_AFTER_MS))
  return {
    state: pressure >= 1 ? 'tired' : 'dim',
    awayMs,
    light: 0.8 - pressure * 0.35,
    emberEnergy: 0.85 - pressure * 0.3,
  }
}
